import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'Download',
    path: 'downloads',
    component: () => import('./views/DownloadView.vue'),
  },
  {
    name: 'Invite',
    path: 'invite',
    alias: ['invite_members', 'invite_collaborators'],
    component: () => import('./views/InviteView.vue'),
    props: route => ({ redirectTo: route.query.return_to ?? 'downloads' }),
  },
];
